import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog";
import { forwardRef, type ComponentPropsWithoutRef, type ReactNode } from "react";
import { AlertDialogOverlay, AlertDialogPortal } from "../../components/ui/alert-dialog/index.js";
import { cn } from "../../lib/utils.js";
import { contactsModalPanelClass, contactsModalPositionerClass } from "./contacts-dialog-presentation.js";

export const ContactsModalContent = forwardRef<
  React.ElementRef<typeof AlertDialogPrimitive.Content>,
  ComponentPropsWithoutRef<typeof AlertDialogPrimitive.Content> & { children: ReactNode }
>(function ContactsModalContent({ className, children, ...props }, ref) {
  return (
    <AlertDialogPortal>
      <AlertDialogOverlay />
      <AlertDialogPrimitive.Content
        ref={ref}
        className={contactsModalPositionerClass}
        {...props}
      >
        <div className={cn(contactsModalPanelClass, className)} data-contacts-modal-panel>
          {children}
        </div>
      </AlertDialogPrimitive.Content>
    </AlertDialogPortal>
  );
});
